import Vue from 'vue';
import vuex from 'vuex';
Vue.use(vuex);


function hasDuplicate(arr, payload) {
    return arr.some(item => item.path == payload.path);
}

const stores = {
    state: {
        admin: null,
        fails: 0
    },
    mutations: {
        setAdmin(state, admin) {
            state.admin = admin
        },
        setFails(state, fails) {
            state.fails = fails
        }
    }
}

const tabStore = {
    state: {
        openTab: [
            {
                path: "/",
                meta: { title: "首页" }
            }
        ],
        windowWidth:0,
    },
    mutations: {
        addOpenTab(state, payload) {
            // 添加页签
            const { openTab } = state;
            if (!hasDuplicate(openTab, payload) && payload.name!="login" && payload.name!="404") {
                state.openTab = [...openTab, payload];
            }
        },
        setOpenTab(state, payload) {
            state.openTab = payload;
        },
        resetOpenTab(state){
            state.openTab = [{
                path: "/",
                meta: { title: "首页" }
            }];
        },
        setWindowWidth(state,payload){
			state.windowWidth = payload;
		}
    }
}

export default new vuex.Store({
    modules: {
        stores: stores,
        tabStore: tabStore,
    }
})